import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useState } from "react";
import ravenLogo from "@/assets/raven-logo.png";

export function LandingNavbar() {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-lg border-b border-border">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center gap-2 cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <img src={ravenLogo} alt="Raven Logo" className="h-8 w-8" />
            <span className="text-xl font-bold text-primary">Raven</span>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-6">
            <button onClick={() => scrollToSection('features')} className="text-muted-foreground hover:text-primary transition-colors">
              Características
            </button>
            <button onClick={() => scrollToSection('benefits')} className="text-muted-foreground hover:text-primary transition-colors">
              Beneficios
            </button>
            <button onClick={() => scrollToSection('faq')} className="text-muted-foreground hover:text-primary transition-colors">
              FAQ
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-muted-foreground hover:text-primary transition-colors">
              Contacto
            </button>
          </div>

          {/* Desktop CTAs */}
          <div className="hidden md:flex items-center gap-3">
            <Button variant="ghost" onClick={() => navigate('/login')}>
              Iniciar Sesión
            </Button>
            <Button onClick={() => scrollToSection('contact')}>
              Solicitar Demo
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 text-muted-foreground hover:text-primary"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 space-y-3 animate-fade-in">
            <button onClick={() => scrollToSection('features')} className="block w-full text-left px-4 py-2 text-muted-foreground hover:text-primary hover:bg-muted/50 rounded-lg transition-colors">
              Características
            </button>
            <button onClick={() => scrollToSection('benefits')} className="block w-full text-left px-4 py-2 text-muted-foreground hover:text-primary hover:bg-muted/50 rounded-lg transition-colors">
              Beneficios
            </button>
            <button onClick={() => scrollToSection('faq')} className="block w-full text-left px-4 py-2 text-muted-foreground hover:text-primary hover:bg-muted/50 rounded-lg transition-colors">
              FAQ
            </button>
            <button onClick={() => scrollToSection('contact')} className="block w-full text-left px-4 py-2 text-muted-foreground hover:text-primary hover:bg-muted/50 rounded-lg transition-colors">
              Contacto
            </button>
            <div className="flex flex-col gap-2 px-4 pt-2">
              <Button variant="ghost" onClick={() => navigate('/login')} className="w-full">
                Iniciar Sesión
              </Button>
              <Button onClick={() => scrollToSection('contact')} className="w-full">
                Solicitar Demo
              </Button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
